import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "news-card__image-wrapper" }
const _hoisted_2 = { class: "news-card__inner-container" }
const _hoisted_3 = {
  key: 0,
  class: "timer news-card__timer"
}
const _hoisted_4 = { class: "timer__text" }
const _hoisted_5 = {
  key: 1,
  class: "news-card__gallery-badge"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Galéria ")
const _hoisted_7 = {
  key: 3,
  class: "news-card__title"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 5,
  class: "news-card__excerpt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Play = _resolveComponent("Play")!
  const _component_GalleryFull = _resolveComponent("GalleryFull")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_ContentImage = _resolveComponent("ContentImage")!
  const _component_nav_link = _resolveComponent("nav-link")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["news-card news-card--full-image", {
      'news-card--full-image--medium': _ctx.size === 'medium',
      'news-card--full-image--large': _ctx.size === 'large'
    }])
  }, [
    _createVNode(_component_nav_link, { to: _ctx.url }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.showDuration && _ctx.isVideo && _ctx.videoDuration)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_Play, { class: "timer__play" }),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.videoDuration), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showGalleryBadge && _ctx.isGallery)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_GalleryFull),
                  _hoisted_6
                ]))
              : _createCommentVNode("", true),
            (_ctx.showTag && _ctx.tag)
              ? (_openBlock(), _createBlock(_component_Tag, {
                  key: 2,
                  tag: _ctx.tag,
                  class: "news-card__tag",
                  "is-live": _ctx.isLive
                }, null, 8, ["tag", "is-live"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ContentImage, {
              class: "news-card__image",
              "image-url": _ctx.imageUrl,
              "preview-url": _ctx.previewUrl,
              "is-lcp": _ctx.isLcp
            }, null, 8, ["image-url", "preview-url", "is-lcp"]),
            (_ctx.showTitle && _ctx.title)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            (_ctx.showLead && _ctx.lead)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  innerHTML: _ctx.lead,
                  class: _normalizeClass(["news-card__excerpt", { 'news-card__excerpt--cropped': _ctx.leadCropping }])
                }, null, 10, _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.showReleaseDate && _ctx.releaseDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$d(_ctx.releaseDate, 'long')), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}